<template>
  <div class="installation-instructions category-installation-instructions">
    <GlobalHeader
      :iconType="instructions.headerIcon || brandTheme.globalHeader.headerIcon"
      :instructions="instructions"
    />

    <div class="page-content-container" id="page-content-container">
      <BaseCarousel
        v-if="instructions && instructions.carousel"
        :instructions="instructions"
      />
      <HomeAdvisorBanner v-if="instructions.includeBanner" />

      <p
        v-if="instructions.title || instructions.titleTx"
        class="instruction-page-title"
        :name="`${instructions.currentStep}_pageTitle`"
        :id="`${instructions.currentStep}_pageTitle`"
      >{{ instructions.titleTx ? $t(instructions.titleTx) : instructions.title }}</p>

      <BaseResource
        v-if="instructions.resource"
        :instructions="instructions"
      />

      <div class="page-content" v-if="!instructions.carousel">
        <p
          v-if="instructions.primaryText || instructions.primaryTx"
          class="instruction-title"
          :name="`${instructions.currentStep}_primaryText`"
          :id="`${instructions.currentStep}_primaryText`"
        >{{ instructions.primaryTx ? $t(instructions.primaryTx) : instructions.primaryText }}</p>
        <template v-if="shouldIterateSecondaryText">
          <p
            v-for="(text, index) in instructions.secondaryText"
            :key="`${instructions.currentStep}_secondaryText${index}`"
            :name="`${instructions.currentStep}_secondaryText${index}`"
            :id="`${instructions.currentStep}_secondaryText${index}`"
            :class="['instruction-subtitle', instructions.additionalSecondaryTextClasses]"
          >{{ text }}</p>
        </template>
        <p
          v-else
          :name="`${instructions.currentStep}_secondaryText`"
          :id="`${instructions.currentStep}_secondaryText`"
          :class="['instruction-subtitle', instructions.additionalSecondaryTextClasses]"
        >{{ instructions.secondaryTx ? $t(instructions.secondaryTx) : instructions.secondaryText }}</p>

        <BaseSteps
          v-if="instructions.steps && instructions.steps.length > 0"
          :instructions="instructions"
        />
      </div>

      <ButtonFooter
        v-if="!instructions.carousel"
        :instructions="instructions"
      />
    </div>
  </div>
</template>

<script>
import BaseCarousel from '../components/BaseCarousel.vue';
import BaseResource from '../components/BaseResource.vue';
import BaseSteps from '../components/BaseSteps.vue';
import GlobalHeader from '../components/GlobalHeader';
import HomeAdvisorBanner from '../components/HomeAdvisorBanner';
import ButtonFooter from '../components/ButtonFooter';

import { mapState } from 'vuex';
import { get } from 'lodash';

export default {
  name: 'CategoryInstructions',
  components: {
    BaseCarousel,
    BaseResource,
    BaseSteps,
    ButtonFooter,
    GlobalHeader,
    HomeAdvisorBanner
  },
  computed: {
    ...mapState(['brands']),
    shouldIterateSecondaryText() {
      return Array.isArray(get(this.instructions, 'secondaryText', ''));
    },
    brandTheme() {
      const { brand } = this.$route.params;
      return get(this, ['brands', brand, 'theme'], {});
    },
    instructions() {
      const { brand, category, step } = this.$route.params;
      const { returnToApp } = this.$route.query;
      const instructions = get(this, ['brands', brand, 'categories', category, 'installationInstructions', step]);
      if (instructions && returnToApp) {
        instructions.prevStepName = 'https://return-to-app';
      }
      return instructions || {};
    }
  },
  beforeCreate() {
    const { brand } = this.$route.params;
    document.body.classList.add(brand);
  }
};
</script>
